module.exports = __webpack_public_path__ + "static/media/Launchpad.690bd764.jpg";